import i18n from "@/i18n";

/** Parse an API timestamp; timestamps without an offset are UTC. */
export function parseApiDate(value: string): Date {
  return new Date(/[zZ]|[+-]\d\d:\d\d$/.test(value) ? value : `${value}Z`);
}

function locale(): string {
  return i18n.language === "it" ? "it-IT" : i18n.language;
}

export function formatNumber(value: number): string {
  return new Intl.NumberFormat(locale()).format(value);
}

export function formatMonthYear(value: string): string {
  return new Intl.DateTimeFormat(locale(), { month: "long", year: "numeric" }).format(parseApiDate(value));
}

export function formatDateTime(value: string): string {
  return new Intl.DateTimeFormat(locale(), { dateStyle: "short", timeStyle: "short" }).format(
    parseApiDate(value),
  );
}

const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"] as const;

/** 14249853618 -> "13,3 GB" (binary multiples, one decimal from KB up). */
export function formatBytes(value: number): string {
  let amount = value;
  let unit = 0;
  while (amount >= 1024 && unit < BYTE_UNITS.length - 1) {
    amount /= 1024;
    unit += 1;
  }
  const digits = unit === 0 ? 0 : 1;
  return `${new Intl.NumberFormat(locale(), { maximumFractionDigits: digits, minimumFractionDigits: digits }).format(amount)} ${BYTE_UNITS[unit]}`;
}

/** 75 -> "1 min", 5400 -> "1 h 30 min"; under a minute -> "< 1 min". */
export function formatDuration(seconds: number): string {
  const minutes = Math.round(seconds / 60);
  if (minutes < 1) return "< 1 min";
  if (minutes < 60) return `${minutes} min`;
  const rest = minutes % 60;
  return rest ? `${Math.floor(minutes / 60)} h ${rest} min` : `${minutes / 60} h`;
}
